export default "__VITE_ASSET__BFepfCbU__"